import HttpCLient from '@/src/lib/utils/httpClient';
import { ApiRouts } from '@/src/routes/routes';
import {
  BranchRequest,
  DestinationProductRequest,
  DestinationProductsRequest,
  DestinationStoreRequest,
  DestinationStoresRequest,
  ProductDetailsRequest,
} from './types';
import { getLatAndLongFromCookies } from '@/src/lib/actions/getCookies';
import { BasicProductDataResponse } from '@/src/types/catalog';

class DestinationApi extends HttpCLient {
  getDestinationStore = async (payload: DestinationStoreRequest): Promise<BranchRequest[]> => {
    const cookieCoords = await getLatAndLongFromCookies();

    const coords = {
      latitude: Number(cookieCoords?.latitude),
      longitude: Number(cookieCoords?.longitude),
    };
    try {
      const response = await this.post(ApiRouts.destinationStore, { ...payload, ...coords });
      return response;
    } catch (error) {
      console.error('Failed to fetch store destination:', error);
      throw error;
    }
  };

  getDestinationStores = async (payload: DestinationStoresRequest): Promise<BranchRequest[]> => {
    const cookieCoords = await getLatAndLongFromCookies();

    const coords = {
      latitude: Number(cookieCoords?.latitude),
      longitude: Number(cookieCoords?.longitude),
    };

    try {
      const response = await this.post<any>(ApiRouts.destinationStores, { ...payload, ...coords });
      return response;
    } catch (error) {
      console.error('Failed to fetch stores destination:', error);
      throw error;
    }
  };

  getDestinationProduct = async (
    payload: DestinationProductRequest,
  ): Promise<ProductDetailsRequest> => {
    const cookieCoords = await getLatAndLongFromCookies();

    const coords = {
      latitude: Number(cookieCoords?.latitude),
      longitude: Number(cookieCoords?.longitude),
    };

    try {
      const response = await this.post<ProductDetailsRequest>(ApiRouts.destinationProduct, {
        ...payload,
        ...coords,
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch product destination:', error);
      throw error;
    }
  };

  getDestinationProducts = async (
    payload: DestinationProductsRequest,
  ): Promise<BasicProductDataResponse[]> => {
    const cookieCoords = await getLatAndLongFromCookies();

    const coords = {
      latitude: Number(cookieCoords?.latitude),
      longitude: Number(cookieCoords?.longitude),
    };

    try {
      const response = await this.post(ApiRouts.destinationProducts, { ...payload, ...coords });
      return response;
    } catch (error) {
      console.error('Failed to fetch products destination:', error);
      throw error;
    }
  };
}

export const destinationApi = new DestinationApi();
